import { MarketResearchNormalizedJobTitleData, SummaryRating } from "../..";
import { MarketResearchNormalizedJobTitleResponse } from "./marketResearchNormalizedJobTitleResponse";

export const convertNormalizedJobTitle = (
    res: MarketResearchNormalizedJobTitleResponse
): MarketResearchNormalizedJobTitleData => {
    if (!res) return null;

    return {
        jobName: res.jobName,
        confidencePercentage: res.confidencePercentage,
        rating: SummaryRating.fromId(res.ratingTypeId),
    };
};
